export enum EInfoDetail {
    BRIEF = 'brief',
    FULL = 'full'
}

export enum EUserDetail {
    BRIEF = 'brief',
    FULL = 'full',
    ME_FULL = 'me-full',
    ME_BRIEF = 'me-brief'
}

export enum EUserProfileDataType {
    PROFILE_PICTURE = 'profile-picture',
    TITLE_PICTURE = 'title-picture',
    INTRO_VIDEO = 'intro-video'
}

export enum EUserType {
    NO_USER = 'no-user',
    ADMIN = 'admin',
    EMPLOYER = 'employer',
    EMPLOYERSUB = 'employerSub',
    FREELANCER = 'freelancer'
}